export function shouldChargeMerchantForDamagedOrWrongProduct({
  damaged,
  wrongProduct,
  dontChargeMerchantForDamagedOrWrongProductReturnLabels,
}: {
  damaged: boolean;
  wrongProduct: boolean;
  dontChargeMerchantForDamagedOrWrongProductReturnLabels?: boolean | null;
}) {
  return (
    (damaged || wrongProduct) &&
    !dontChargeMerchantForDamagedOrWrongProductReturnLabels
  );
}
